<div class="avatar-container">
  <div class="user-avatar bigger-badge"
       matBadge="{{application.user.rank}}" matBadgeColor="accent">
    <img src="{{application.user.picture_src_preview ? application.user.picture_src_preview : '/images/assets/def_prof_preview_male.png'}}" />
  </div>
  <div class="user-avatar-label">{{application.user.shipping_name}}</div>
</div>
